import { render, staticRenderFns } from "./WelcomeStep2Page.vue?vue&type=template&id=69731bfa&scoped=true"
import script from "./WelcomeStep2Page.vue?vue&type=script&lang=ts"
export * from "./WelcomeStep2Page.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeStep2Page.vue?vue&type=style&index=0&id=69731bfa&prod&scoped=true&lang=scss"
import style1 from "./WelcomeStep2Page.vue?vue&type=style&index=1&id=69731bfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69731bfa",
  null
  
)

export default component.exports